function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as l } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: n , size: o = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = l(), t = n !== null && n !== void 0 ? n : s ? i.colors.inverse : i.colors.neutralHigh, { skinName: c  } = h();
    return c.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: t,
                d: "M2 12c0 5.5 4.5 10 10 10a10.14 10.14 0 005.356-1.536c.18-.108.216-.32.108-.5s-.32-.216-.5-.108A9.43 9.43 0 0112 21.284c-5.108 0-9.284-4.176-9.284-9.284 0-5.108 4.18-9.284 9.284-9.284 5.104 0 9.284 4.176 9.284 9.248 0 1.784-.5 3.5-1.428 4.964-.108.18-.072.392.108.5.18.108.392.072.5-.108A9.925 9.925 0 0022 12c0-5.5-4.5-10-10-10S2 6.5 2 12z"
            }),
            /* @__PURE__ */ r("path", {
                fill: t,
                d: "M18.784 19.5a.716.716 0 100-1.432.716.716 0 000 1.432zM12 17.356c-.216 0-.356-.144-.356-.356V9.5c0-.216.144-.356.356-.356.216 0 .356.144.356.356V17c0 .216-.14.356-.356.356zm0-9.64a.536.536 0 100-1.072.536.536 0 000 1.072z"
            })
        ]
    })) : /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ r("path", {
            fill: t,
            d: "M23 12.037C23 1.832 14.71 1.033 12.5 1.002a35.82 35.82 0 00-1.004.003C9.396 1.043 1 1.832 1 11.971c0 10.115 8.386 10.966 10.543 11.02.254.006.548.009.83.009h.21C14.788 22.981 23 22.224 23 12.037zm-.917 0c0 4-1.33 6.868-3.954 8.518-2.15 1.352-4.601 1.518-5.556 1.528h-.204c-.275 0-.56-.003-.807-.01-.958-.025-3.428-.225-5.613-1.596-2.676-1.675-4.032-4.54-4.032-8.506 0-9.16 7.344-10.008 9.595-10.049.325-.006.65-.006.976-.003.961.013 3.431.194 5.604 1.562 2.648 1.669 3.99 4.549 3.99 8.556zM12.006 9.495c.254 0 .457.207.457.457v7.15a.458.458 0 01-.914 0V9.955a.456.456 0 01.457-.46zm.708-1.884a.713.713 0 10-1.427-.001.713.713 0 001.427 0z"
        })
    }));
}, g = m;
export { g as default };
